import React from 'react';
import Config from '../../assets/config.json';

class Counter extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			num: 0,
			int: true
		}
		this.interval = false;
		this.IsInt = this.IsInt.bind(this);
		this.Count = this.Count.bind(this);
	}

	componentDidUpdate(prevProps, prevState) {
		if ((!prevProps
			&& this.props.hasOwnProperty('num')
			&& this.props.num > 0)
			||
			(prevProps
				&& prevProps.hasOwnProperty('num')
				&& prevProps.num !== this.props.num)) {
			let prevNum = prevProps && prevProps.hasOwnProperty('num') ? prevProps.num : 0;

			this.Count(prevNum, this.props.num);
		}
	}

	IsInt(num) {
		return num % 1 === 0;
	}

	Count(prevNum, num) {
		clearInterval(this.interval);

		let how;
		let step = 0;
		const steps = 16;

		//

		how = prevNum < num ? '+' : '-';
		step = parseFloat((Math.abs(num - prevNum) / steps).toFixed(1));

		if (this.IsInt(prevNum)
			&& this.IsInt(num)) {
			step = Math.floor(step);
			this.setState({ int: true });
		}
		else
			this.setState({ int: false });

		if (!step)
			step = 1;

		//

		this.interval = setInterval(() => {
			if (how === '+')
				prevNum = prevNum + step;
			else
				prevNum = prevNum - step;

			if ((how === '+' && prevNum >= num)
				|| (how === '-' && prevNum <= num)) {
				this.setState({ num: num });
				clearInterval(this.interval);
			}
			else
				this.setState({ num: prevNum });
		}, 100);
	}

	render() {
		return <>
			{Intl.NumberFormat(Config.LOCALE, { minimumFractionDigits: (this.state.int ? 0 : 1) }).format(this.state.num)}
		</>
	}
}

export default Counter;